import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const OshikatsuPage = lazy(() => import('../pages/oshikatsu/page'));
const MemoryPage = lazy(() => import('../pages/memory/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const RankingPage = lazy(() => import('../pages/ranking/page'));
const BillingPage = lazy(() => import('../pages/billing/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment-success/page'));
const PaymentFailurePage = lazy(() => import('../pages/payment-failure/page'));
const NotificationsPage = lazy(() => import('../pages/notifications/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const IdolPersonaPage = lazy(() => import('../pages/idol-persona/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminPersonaPage = lazy(() => import('../pages/admin/persona/page'));
const AdminConversationStylePage = lazy(() => import('../pages/admin/conversation-style/page'));
const AdminSafetyPage = lazy(() => import('../pages/admin/safety/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const Fallback = () => (
  <div className="flex items-center justify-center h-screen bg-white">
    <div className="w-10 h-10 border-4 border-[#06C755] border-t-transparent rounded-full animate-spin" />
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Suspense fallback={<Fallback />}><HomePage /></Suspense>,
      },
      {
        path: 'chat',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'dashboard',
        element: <Suspense fallback={<Fallback />}><DashboardPage /></Suspense>,
      },
      {
        path: 'oshikatsu',
        element: <Suspense fallback={<Fallback />}><OshikatsuPage /></Suspense>,
      },
      {
        path: 'memory',
        element: <Suspense fallback={<Fallback />}><MemoryPage /></Suspense>,
      },
      {
        path: 'settings',
        element: <Suspense fallback={<Fallback />}><SettingsPage /></Suspense>,
      },
      {
        path: 'idol-persona',
        element: <Suspense fallback={<Fallback />}><IdolPersonaPage /></Suspense>,
      },
      {
        path: 'admin/dashboard',
        element: <Suspense fallback={<Fallback />}><AdminDashboardPage /></Suspense>,
      },
      {
        path: 'admin/persona',
        element: <Suspense fallback={<Fallback />}><AdminPersonaPage /></Suspense>,
      },
      {
        path: 'admin/conversation-style',
        element: <Suspense fallback={<Fallback />}><AdminConversationStylePage /></Suspense>,
      },
      {
        path: 'admin/safety',
        element: <Suspense fallback={<Fallback />}><AdminSafetyPage /></Suspense>,
      },
      {
        path: 'ranking',
        element: <Suspense fallback={<Fallback />}><RankingPage /></Suspense>,
      },
      {
        path: 'billing',
        element: <Suspense fallback={<Fallback />}><BillingPage /></Suspense>,
      },
      {
        path: 'checkout',
        element: <Suspense fallback={<Fallback />}><CheckoutPage /></Suspense>,
      },
      {
        path: 'payment-success',
        element: <Suspense fallback={<Fallback />}><PaymentSuccessPage /></Suspense>,
      },
      {
        path: 'payment-failure',
        element: <Suspense fallback={<Fallback />}><PaymentFailurePage /></Suspense>,
      },
      {
        path: 'notifications',
        element: <Suspense fallback={<Fallback />}><NotificationsPage /></Suspense>,
      },
      {
        path: 'terms',
        element: <Suspense fallback={<Fallback />}><TermsPage /></Suspense>,
      },
      {
        path: 'privacy',
        element: <Suspense fallback={<Fallback />}><PrivacyPage /></Suspense>,
      },
      {
        path: 'legal',
        element: <Suspense fallback={<Fallback />}><LegalPage /></Suspense>,
      },
      {
        path: '*',
        element: <Suspense fallback={<Fallback />}><NotFoundPage /></Suspense>,
      },
    ],
  },
];

export default routes;